import styled from 'styled-components';
import MuiAlertTitle from "@material-ui/lab/AlertTitle";

export const StyledMuiAlertTitle = styled(MuiAlertTitle)`
  && { }
`;
